module.exports = __webpack_public_path__ + "static/img/97071A_X_05_20170621_LC.bb6cb65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/97071A_X_05_20170621_LC.png
// module id = fYGb
// module chunks = 0